import { getUrlInfo } from 'utils/helperFunctions';

const { protocol, domain, subdomain } = getUrlInfo();

export let BACKEND_URL: string | undefined;
export let WEB_EMBED_SCRIPT: string | undefined;
export let WORKFLOW_APP_URL: string | undefined;
export let WORKFLOW_API_URL: string | undefined;

if (import.meta.env.VITE_APP_ENV === 'development') {
  BACKEND_URL = `${protocol}//api-${subdomain}.lvh.me:3000${import.meta.env.VITE_APP_API_VERSION}`;
  WEB_EMBED_SCRIPT = `${protocol}//localhost:8080/embed.js`;
  WORKFLOW_APP_URL = import.meta.env.VITE_APP_WORKFLOW_APP_URL || `${protocol}//localhost:4200`;
  WORKFLOW_API_URL = import.meta.env.VITE_APP_WORKFLOW_API_URL || `${protocol}//localhost:3001`;
} else {
  BACKEND_URL = `${protocol}//api-${domain}${import.meta.env.VITE_APP_API_VERSION}`;
  WEB_EMBED_SCRIPT = `${protocol}//voicebot-${domain}/embed.js`;
  WORKFLOW_APP_URL = import.meta.env.VITE_APP_WORKFLOW_APP_URL || `${protocol}//workflows-${domain}`;
  WORKFLOW_API_URL = import.meta.env.VITE_APP_WORKFLOW_API_URL || `${protocol}//workflows-${domain}`;
}
